import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgNotaris = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F1F4FB"
      fillRule="evenodd"
      d="M8 34h20V12l-4-2-2-4H8v28"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M31 31.18v-.98l-6-.2v6l3-2.55L31 36z"
      clipRule="evenodd"
    />
    <path
      fill="#E0E8F6"
      fillRule="evenodd"
      d="m22 6 2.98 2.98 2.99 2.99H22z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M28 32a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M23.814 23.814a4.506 4.506 0 1 0 6.372 6.372l.707.708a5.506 5.506 0 0 1-7.787-7.788zM20 14.5H10v-1h10zM18 17.5h-8v-1h8zM18 30.5h-8v-1h8zM19 20.5h-9v-1h9z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgNotaris);

export default ForwardRef;
